<template>
  <div class="w-screen h-screen overflow-hidden">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MonitorFeed from '@/views/monitor/MonitorFeed'

export default {
  name: 'Dispatch',

  metaInfo () {
    const accountName = this.account.name
    return {
      title: 'Dispatch',
      titleTemplate: `%s | ${accountName}`
    }
  },

  components: {
    MonitorFeed
  },

  computed: {
    ...mapGetters(['account'])
  },
  
  data () {
    return {

    }
  }
}
</script>